<section class="workspace home-brand-area">
  <img class="home-brand-image" [src]="homeLogoSrc" alt="Global Parts Logo" width="640" height="440">
</section>
